import React from 'react';
import flags from './flags';
const Flag = ({ code, size = '24px', alt = code }) => (
  <img width={size} className="ws-ui-flag" src={flags[code]} alt={alt} />
);

export default Flag;
